import {Combobox, Text, TextInput, useCombobox} from "@mantine/core";
import React from "react";
import {IStimDevice} from "../../common/types/StimDevice";
import {TStimMetadata} from "../../common/types/TStimConfig";
import classes from "@/protocols/common/steps/StepView.module.css";

export interface BscProgramsStimulatorProps {
    device: IStimDevice
    metadata: Partial<TStimMetadata>
    onChange: (metadata: Partial<TStimMetadata>) => void
    readonly?: boolean
}

const PRESET_PROGRAMS: string[] = ["Program A", "Program B", "Program C", "Program D"];

export const BscProgramsStimulator: React.FC<BscProgramsStimulatorProps> = ({
                                                                                device,
                                                                                metadata,
                                                                                onChange,
                                                                                readonly = false
                                                                            }) => {
    const combobox = useCombobox({
        onDropdownClose: () => combobox.resetSelectedOption(),
    });

    const programName = metadata.program_name || "";

    const handleProgramSelect = (value: string) => {
        onChange({program_name: value});
        combobox.closeDropdown();
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange({program_name: e.currentTarget.value});
    };

    return (
        <>
            <Text
                size={"xs"}
                c="dimmed"
                style={{gridColumn: "1 / -1", textAlign: "center"}}
            >
                Program-based stimulation - select or enter program name
            </Text>
            <div className={classes.stimParamCol} style={{gridColumn: "1 / -1"}}>
                <Combobox
                    store={combobox}
                    onOptionSubmit={handleProgramSelect}
                >
                    <Combobox.Target>
                        <TextInput
                            data-testid="input-program-name"
                            label="Program Name"
                            miw={"20rem"}
                            size="xs"
                            placeholder={PRESET_PROGRAMS.length > 0 ? "Select or type program name" : "Enter program name"}
                            value={programName}
                            onChange={handleInputChange}
                            onClick={() => combobox.toggleDropdown()}
                            className={classes.stepViewInputNarrow}
                            disabled={readonly}
                        />
                    </Combobox.Target>
                    {PRESET_PROGRAMS.length > 0 && (
                        <Combobox.Dropdown>
                            <Combobox.Options>
                                {PRESET_PROGRAMS.map((program) => (
                                    <Combobox.Option key={program} value={program}>
                                        {program}
                                    </Combobox.Option>
                                ))}
                            </Combobox.Options>
                        </Combobox.Dropdown>
                    )}
                </Combobox>
            </div>
        </>
    );
};